import React from "react";
import { Link as RouterLink } from "react-router-dom";



const AppBreadcrumbs = ({ items = [], className = "" }) => {
  if (!Array.isArray(items) || items.length === 0) return null;

  return (
    <nav className={`ds-breadcrumb ${className}`.trim()} aria-label="Breadcrumb">
      <ol className="ds-breadcrumb__list">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          const label = item?.label ?? "";
          const to = item?.to;

          return (
            <li key={`${label}-${index}`} className="ds-breadcrumb__item">
              {!isLast && to ? (
                <RouterLink to={to} className="ds-breadcrumb__link">
                  {label}
                </RouterLink>
              ) : !isLast && item?.onClick ? (
                <button
                  type="button"
                  className="ds-breadcrumb__link ds-breadcrumb__btn"
                  onClick={item.onClick}
                >
                  {label}
                </button>
              ) : (
                <span
                  className={
                    isLast ? "ds-breadcrumb__current" : "ds-breadcrumb__text"
                  }
                >
                  {label}
                </span>
              )}
              {!isLast ? <span className="ds-breadcrumb__sep">/</span> : null}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default AppBreadcrumbs;
